import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDirection1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"direction-1, route"} maskId="square-filled-radius-0-stroke-1-IconDirection1"><path fillRule="evenodd" clipRule="evenodd" d="M11.4994 3H19.767L23.1003 8L19.767 13H12.4994V21H11.4994V17H4.23177L0.898438 12L4.23177 7H11.4994V3ZM12.4994 12H19.2318L21.8984 8L19.2318 4H12.4994V12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDirection1;
